<!-- 优算云云机引流活动 -->
<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="disabledPull || !isLive"
    @refresh="onRefresh"
  >
    <div v-if="!isLive" class="pageNative flex_center">
      <div
        v-if="isNotStart"
        class="nativeStatus flex_center"
      >
        活动将于 {{ actInfo.startTime }} 开始
      </div>
      <div
        v-if="isPassed"
        class="nativeStatus flex_center"
      >
        活动已结束
      </div>
    </div>
    <div v-else class="page">
      <div class="main">
        <div class="templateContent">
          <img class="image" :src="actInfo.actIcon" />
          <img
            v-if="actInfo.showButton == 1"
            class="btn copyFissionDeviceCodeCdk"
            :src="actInfo.buttonIcon"
            @click="onClickBtn"
          />
        </div>
      </div>
      <!-- cancel-button-color="#ccc" -->
      <ActivityPopup
        :visible.sync="visible"
        v-bind="feedback"
        @confirm="feedback.onSure"
        @cancel="feedback.onCancel"
      >
      </ActivityPopup>
    </div>
  </PullRefresh>
</template>

<script>
import {
  setPageTitle,
} from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import ActivityPopup from "@/components/btBox/ActivityPopup";
import EventTrack from '@/mixins/eventTrack'
import LinkTo from '@/mixins/linkTo'
import { getWxTemplateApi, drawCloudReward } from "@/apis/wxActivity";
import AvoidFirstActivate from '@/mixins/avoidFirstActivate'
import { CloudActInfo } from "./config";
import { jumpToNative } from "@/bridge/AppJsBridge";

export default {
  components: {
    PullRefresh,
    ActivityPopup,
  },
  mixins: [EventTrack, AvoidFirstActivate],
  data () {
    return {
      isWx: true,
      actInfo: new CloudActInfo(),
      hasFetched: false,
      disabledPull: false,
      isLoading: false,
      feedbackType: 'NOT_SATISFIED',
      visible: false,
    }
  },
  activated () {
    this.hasFetched = false
    if (this.actInfo.pageTitle) {
      setPageTitle(this.actInfo.pageTitle)
    }
  },
  computed: {
    actId () {
      return this.$route.query.id
    },
    isLive () {
      if (!this.hasFetched) return true
      if (!this.actInfo.id && this.hasFetched) return false
      return !this.isNotStart && !this.isPassed
    },
    isPassed () {
      const { endTime } = this.actInfo
      const now = Date.now()
      return now > new Date(endTime).getTime()
    },
    isNotStart () {
      const { startTime } = this.actInfo
      const now = Date.now()
      return now < new Date(startTime).getTime()
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return {
        SUCCESS: {
          title: '领取成功',
          message: [
            '恭喜您成功获得免费云挂机',
            '有效期：3天',
          ],
          confirmButtonText: '去使用',
          onSure: () => {
            this.onSureGet()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
        NOT_SATISFIED: {
          title: '温馨提示',
          message: [
            '您不符合活动参与条件',
            '去看看盒子其他福利吧',
          ],
          confirmButtonText: '去礼包中心',
          cancelButtonText: '取消',
          showCancelButton: true,
          onSure: () => {
            this.triggerVisible(false)
            this.onGoGift()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
        SOLD_OUT: {
          title: '温馨提示',
          message: [
            '今日云挂机已抢光',
            '去看看盒子其他福利吧',
          ],
          confirmButtonText: '去礼包中心',
          cancelButtonText: '取消',
          showCancelButton: true,
          onSure: () => {
            this.triggerVisible(false)
            this.onGoGift()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
        HAVE_GOT: {
          title: '温馨提示',
          message: [
            '您已获得过云挂机',
            '去看看盒子其他福利吧',
          ],
          confirmButtonText: '去礼包中心',
          cancelButtonText: '取消',
          showCancelButton: true,
          onSure: () => {
            this.triggerVisible(false)
            this.onGoGift()
          },
          onCancel: () => {
            this.triggerVisible(false)
          },
        },
      }
    },
    commonTrackParams () {
      return {
        activity_id: this.actInfo.id,
        activity_name: this.actInfo.actTitle,
      }
    },
  },
  methods: {
    init () {
      return this.getTemplateInfo().then(res => {
        this.hasFetched = true
      })
    },
    getActivityInfo () {
      this.init()
    },
    onRefresh () {
      this.init().finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 300)
      })
    },
    getTemplateInfo () {
      return getWxTemplateApi({ id: this.actId })
        .then((res) => {
          this.actInfo = res.data || new CloudActInfo()
          const { actTitle, type } = this.actInfo
          setPageTitle(actTitle);
          this.$nextTick(() => {
            this.eventTrack({
              event: 'cloud_try_show',
              event_field: JSON.stringify({
                ...this.commonTrackParams
              }),
            });
          })
        })
    },
    onClickBtn () {
      if (this.loading) return 
      this.loading = true
      this.eventTrack({
        event: 'cloud_try_button',
        event_field: JSON.stringify({
          ...this.commonTrackParams
        }),
      });
      drawCloudReward({
        id: this.actId
      }).then(res => {
        if (res.data) {
          this.triggerVisible(true, 'SUCCESS')
          this.eventTrack({
            event: 'cloud_try_popup',
            event_field: JSON.stringify({
              ...this.commonTrackParams,
              type: 4
            }),
          });
        }
      }).catch((err) => {
        const { code, msg } = err
        if ([90300, 90301, 90302].includes(code)) {
          const map = {
            90300: 'NOT_SATISFIED',
            90301: 'SOLD_OUT',
            90302: 'HAVE_GOT'
          }
          this.triggerVisible(true, map[code])
          const typeMap = {
            90300: 1,
            90301: 2,
            90302: 3
          }
          this.eventTrack({
            event: 'cloud_try_popup',
            event_field: JSON.stringify({
              ...this.commonTrackParams,
              type: typeMap[code]
            }),
          });
        } else {
          this.$toast.fail(msg)
        }
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 200)
      })
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
    onGoGift () {
      this.eventTrack({
        event: 'cloud_try_popup_click',
        event_field: JSON.stringify({
          ...this.commonTrackParams,
          type: 1
        }),
      });
      const data = {
        routePath: "gift"
      }
      const dataStr = JSON.stringify(data)
      setTimeout(() => {
        jumpToNative(dataStr)
      }, 200)
    },
    onSureGet () {
      this.eventTrack({
        event: 'cloud_try_popup_click',
        event_field: JSON.stringify({
          ...this.commonTrackParams,
          type: 2
        }),
      });
      this.triggerVisible(false)
      setTimeout(() => {
        const data = {
          routePath: "/cloud/CloudMainActivity",
        }
        const dataStr = JSON.stringify(data)
        jumpToNative(dataStr)
      }, 200)
    },
  },
}
</script>

<style lang="scss" scoped>
.pageNative {
  position: relative;
  height: 100vh;
}
.page {
  font-size: 0px;
}
.templateContent {
  // font-size: 14px;
  width: 100%;
  height: auto;
  .image {
    width: 100%;
  }

  .btn {
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    margin: 0 auto;
  }
}
</style>
